import * as React from "react";
import {
	Box,
	Flex,
	Heading,
	SimpleGrid,
	Spinner,
	VStack,
} from "@chakra-ui/react";

import { ChatBot } from "../../components/ChatBot/ChatBot";
import { useEffect } from "react";


const demoChatBotsData = [
	{
		_id: '66748f5fb0b22e9b6d1c52fd',
		name: 'Konfuzio Server docs',
		description: 'Trained on Konfuzio Server docs. - https://help.konfuzio.com',
		imageUrl: 'https://help.konfuzio.com/_static/logo.png',
		customizationValues:  {
			backgroundColor: "#da5225",
			heading: 'I am your Konfuzio Server launch assistant',
			description: 'I am trained on <a style="text-decoration:underline; font-weight:bold" href="https://help.konfuzio.com" target="_blank">Konfuzio Server docs</a>. Ask me anything you want to know about using Konfuzio Server.',
			fontColor: "#FFF",
			borderRadius: "12px",
			placement: "right",
			welcomeMessage: 'Hello! How can I assist you today?'
		}
	},
	{
		_id: '6684fe95db7859c4bed3300b',
		name: 'Helm & Nagel',
		description: 'Trained on Homepage of Helm & Nagel. - https://helm-nagel.com/',
		imageUrl: 'https://helm-nagel.com/wp-content/uploads/2023/12/helm-nagel-e1703294089610.png',
		customizationValues:  {
			backgroundColor: "#000",
			heading: 'I am your Helm & Nagel AI assistant',
			description: 'I am trained on <a style="text-decoration:underline; font-weight:bold" href="https://helm-nagel.com/" target="_blank">helm-nagel.com</a>. Ask me anything',
			fontColor: "#FFF",
			borderRadius: "12px",
			placement: "right",
			welcomeMessage: 'Hello! How can I assist you today?'
		}
	}
	// {
	// 	_id: '6685219269d4c2c2d4f71d19',
	// 	name: 'Stripe docs',
	// 	description: 'Trained on stripe docs. - https://stripe.com/docs',
	// 	imageUrl: 'https://www.paritydeals.com/images/integrations/stripe-logo.svg',
	// 	customizationValues:  {
	// 		backgroundColor: "#7a73ff",
	// 		heading: 'I am your Stripe AI assistant',
	// 		description: 'I am trained on <a style="text-decoration:underline; font-weight:bold" href="https://stripe.com/docs" target="_blank">Stripe docs</a>. Ask me anything you want to know about Stripe',
	// 		fontColor: "#FFF",
	// 		borderRadius: "12px",
	// 		placement: "right",
	// 		welcomeMessage: 'Hello! How can I assist you today?'
	// 	}
	// }
]

export const DemoChatbots = () => {
	const [chatBotList, setChatBot] = React.useState<any[]>();
	const [chatbotsLoaded, setChatbotsLoaded] = React.useState<boolean>(false);



	useEffect(() => {
		async function fetchData() {
			try {
				setChatbotsLoaded(true);
				setChatBot(demoChatBotsData);
			} catch (error) {
				console.log("Unable to fetch chatbots", error);
			} finally {
			}
		}
		fetchData();
	}, []);

	const getNoDataIcon = React.useCallback(() => {
		return (
			<VStack
				spacing="9"
				alignItems="center"
				direction="column"
				justifyContent="center"
				w="100%"
				h="100%"
			>
				<Heading
					maxW="580px"
					mt={32}
					fontSize="2xl"
					fontWeight="semibold"
					as="h3"
					lineHeight="medium"
					textAlign="center"
				>
					Train Chat GPT on your website's data and create a chatbot within minutes
				</Heading>
			</VStack>
		);
	}, []);
	

	const getChatBotLists = React.useCallback(() => {
		if (!chatbotsLoaded) {
			return (
				<Flex w="100%" minH="300px" justifyContent="center" alignItems="center">
					<Spinner
						thickness="2px"
						speed="0.65s"
						emptyColor="gray.200"
						color="gray.700"
						size="xl"
					/>
				</Flex>
			);
		}
		if (!chatBotList?.length) {
			return getNoDataIcon();
		}
		const chatbotListItems = chatBotList?.map((chatbot) => {
			return	<Flex>
				<ChatBot height={'560px'} knowledgeBaseId={chatbot._id} showCloseButton={false} showLauncher={false} customStyle={chatbot.customizationValues} defaultMessageNumber={0} />
				</Flex>
		});
		return (
			<SimpleGrid columns={[1, 1, 1, 3]} spacing="6">
				{chatbotListItems}
			</SimpleGrid>
		);
	}, [chatBotList, chatbotsLoaded, getNoDataIcon]);


	return (
		<Box
			w="100%"
			maxW="1200px"
			p="6"
			shadow="sm"
			h="100%"
			position="relative"
			overflow="auto"
		>
			<VStack w="100%" spacing="10">
				<Flex shrink={0} w="100%" justifyContent="space-between">
					<Heading fontSize="30">Demo Chatbots</Heading>
				</Flex>
				<Box zIndex='1' width="100%">{getChatBotLists()}</Box>
			</VStack>
		</Box>
	);
};
